import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import ADGMImage from '../ADGMImage';
import styles from './styles';

function EmptyTransaction(props) {
  const { classes } = props;

  return (
    <div className={classes.transactionsNotification}>
      <figure>
        <ADGMImage name='tcimg1.svg' alt='Notification img' />
      </figure>
      <div className={classes.tcTextHolder}>
        <Typography variant='body1' component='h1' className={classes.title}>
          <FormattedMessage {...messages.no_transactions_yet} />
        </Typography>
        <Typography variant='body1'>
          <FormattedMessage {...messages.no_transactions_yet_desc} />
        </Typography>
      </div>
    </div>
  );
}

EmptyTransaction.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EmptyTransaction);
